<script>
import Layout from "@/views/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { Incentive } from "@/path";
import Swal from "sweetalert2";
import moment from "moment";
import RegenerateIcon from "@/views/pages/Dilfoods/Common/icons/RegenerateIcon.vue";
import DownloadIcon from "@/views/pages/Dilfoods/Common/icons/DownloadIcon.vue";

export default {
  components: { Layout, PageHeader, DatePicker, DownloadIcon, RegenerateIcon },
  data() {
    return {
      title: "Incentives",
      headerItems: [
        {
          text: "List",
        },
        {
          text: "Incentive",
          active: true,
        },
      ],
      fields: [
        "from_date",
        "to_date",
        "week_number",
        "restaurants",
        "total_incentive",
        "Download",
      ],
      current_page: 1,
      Incentives: [],
      date_range: null,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  computed: {
    Incentive() {
      return Incentive;
    },
  },
  watch: {
    current_page() {
      this.getIncentives();
    },
  },
  methods: {
    async getIncentives() {
      try {
        let res = await axios.get(this.base_url + Incentive.GET_INCENTIVES, {
          params: {
            page: this.current_page,
          },
        });
        if (res.data.status) {
          this.Incentives = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async generateIncentives(v) {
      try {
        let fromDate, toDate;

        if (v && v.from_date && v.to_date) {
          fromDate = v.from_date;
          toDate = v.to_date;
        } else if (this.date_range && this.date_range.length > 0) {
          const filteredDates = this.date_range.filter((date) => date !== null);
          if (filteredDates.length === 2) {
            fromDate = moment(filteredDates[0]).format("YYYY-MM-DD");
            toDate = moment(filteredDates[1]).format("YYYY-MM-DD");
          }
        }

        if (!fromDate || !toDate) {
          console.error("Invalid date range");
          return;
        }

        const requestData = { from_date: fromDate, to_date: toDate };
        const res = await axios.post(
          this.base_url + Incentive.GENERATIVE_INCENTIVES,
          requestData
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.getIncentives();
        }
      } catch (error) {
        console.error("Error occurred while generating incentives:", error);
      }
    },
    async downloadIncentive(v) {
      try {
        let res = await axios.post(
          this.base_url + Incentive.DOWNLOAD_INVCENTIVES,
          {
            from_date: v.from_date,
            to_date: v.to_date,
          }
        );
        if (res.data.status) {
          window.open(res.data.data.url, "_blank");
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getIncentives();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4 align-items-end">
              <b-col sm="3">
                <b-form-group>
                  <label>Date Range</label>
                  <date-picker
                    range
                    v-model="date_range"
                    show-week-number
                    :lang="lang"
                  ></date-picker>
                </b-form-group>
              </b-col>
              <b-col sm="3" class="mb-3">
                <b-button variant="primary" @click="generateIncentives()"
                  >Generate</b-button
                >
              </b-col>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="Incentives.key"
                :items="Incentives.data"
                :fields="fields"
                responsive="sm"
                :current-page="current_page"
              >
                <template v-slot:cell(week_number)="row">
                  <p>week - {{ row.item.week_number }}</p>
                </template>
                <template v-slot:cell(download)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="downloadIncentive(row.item)">
                      <DownloadIcon />
                    </div>
                    <div @click="generateIncentives(row.item)">
                      <RegenerateIcon :title="'Regenerate'" />
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="Incentives.key"
                      v-model="current_page"
                      :total-rows="Incentives.total"
                      :per-page="Incentives.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style></style>
